import { UrlMatcher, UrlSegment } from '@angular/router';

import { TaskType } from '../shared/enums/task.enum';

/** Task types the task manager page has a table for, they are the first segment of the url */
const URL_TASK_TYPES: string[] = [TaskType.Reader, TaskType.Upload];

/**
 * Matches `reader`, `reader/:taskId`, `upload` and `upload/:taskId` (relative to `tasks`) and gives the route the params `taskType` and `taskId`.
 *
 * Why a matcher and not plain `:taskType/:taskId` routes:
 * - Angular has no optional route params, so a url with and without `taskId` would need two route records. Moving between
 *   records creates the page component again, and opening the task details would reset the table and the filter
 *   (the filter is reset to None when it is created). One matcher keeps a single record, so the component is reused and only
 *   the params change.
 * - It validates the task type, a plain `:taskType` accepts any value (`query` and `form` have no table yet).
 *
 * If the task types ever get separate pages, plain routes can replace the matcher.
 */
export const taskManagerUrlMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  const [taskType, taskId] = segments;
  if (!taskType || segments.length > 2 || !URL_TASK_TYPES.includes(taskType.path)) {
    return null;
  }
  return { consumed: segments, posParams: taskId ? { taskType, taskId } : { taskType } };
};
